import { render } from "./RuleAddMeta.vue?vue&type=template&id=494364fc&scoped=true"
import script from "./RuleAddMeta.vue?vue&type=script&lang=js"
export * from "./RuleAddMeta.vue?vue&type=script&lang=js"

import "./RuleAddMeta.vue?vue&type=style&index=0&id=494364fc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494364fc"]])

export default __exports__